import _objectSpread from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "activityDrawer-container",
    class: _vm.extraClass
  }, [_c("header", [_c("div", {
    staticClass: "title",
    class: _vm.viewType == "notification" ? "selected" : "",
    on: {
      click: function click($event) {
        _vm.viewType = "notification";
        _vm.getNotifications();
      }
    }
  }, [_c("svg", {
    attrs: {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 14 13"
    }
  }, [_c("path", {
    attrs: {
      d: "M2.275 0C1.025 0 0 1.003 0 2.226v5.82c0 1.224 1.025 2.226 2.275 2.226H2.8v1.884c0 .673.85 1.089 1.4.685l3.5-2.569h4.025c1.25 0 2.275-1.002 2.275-2.225V2.226C14 1.003 12.975 0 11.725 0h-9.45zm0 1.027h9.45c.683 0 1.225.531 1.225 1.199v5.82c0 .669-.542 1.2-1.225 1.2h-4.2c-.114 0-.224.035-.315.102l-3.36 2.465V9.76c0-.136-.055-.267-.154-.363-.098-.097-.232-.15-.371-.15h-1.05c-.683 0-1.225-.532-1.225-1.2v-5.82c0-.668.542-1.199 1.225-1.199zM4.37 3.76c-.138.003-.27.06-.366.158L3.5 4.41l-.504-.493c-.049-.05-.107-.089-.172-.116-.065-.026-.134-.04-.204-.04-.105 0-.207.03-.294.088-.086.057-.154.138-.193.232-.04.095-.049.2-.027.3.021.1.073.19.148.262l.504.493-.504.493c-.05.047-.09.104-.119.167-.027.062-.042.13-.043.198 0 .068.013.136.04.2.026.063.065.12.114.169.05.048.108.086.173.112.065.026.134.039.204.038.07 0 .139-.015.203-.042.064-.027.122-.067.17-.116l.504-.493.504.493c.048.05.106.089.17.116.064.027.133.041.203.042.07 0 .14-.012.204-.038.065-.026.123-.064.173-.112.05-.049.088-.106.115-.17.026-.063.04-.13.039-.199-.001-.068-.016-.136-.043-.198-.028-.063-.068-.12-.119-.167l-.504-.493.504-.493c.077-.072.129-.164.15-.266.022-.101.012-.206-.029-.302-.04-.095-.11-.177-.198-.233-.089-.057-.193-.086-.299-.083zm3.5 0c-.138.003-.27.06-.366.158L7 4.41l-.504-.493c-.049-.05-.107-.089-.172-.116-.065-.026-.134-.04-.204-.04-.105 0-.207.03-.294.088-.086.057-.154.138-.193.232-.04.095-.049.2-.027.3.021.1.073.19.148.262l.504.493-.504.493c-.05.047-.09.104-.119.167-.027.062-.042.13-.043.198 0 .068.013.136.04.2.026.063.065.12.114.169.05.048.108.086.173.112.065.026.134.039.204.038.07 0 .139-.015.203-.042.064-.027.122-.067.17-.116L7 5.863l.504.493c.048.05.106.089.17.116.064.027.133.041.203.042.07 0 .14-.012.204-.038.065-.026.123-.064.173-.112.05-.049.088-.106.115-.17.026-.063.04-.13.039-.199-.001-.068-.016-.136-.043-.198-.028-.063-.068-.12-.119-.167l-.504-.493.504-.493c.077-.072.129-.164.15-.266.022-.101.012-.206-.029-.302-.04-.095-.11-.177-.198-.233-.089-.057-.193-.086-.299-.083zm3.5 0c-.138.003-.27.06-.366.158l-.504.493-.504-.493c-.049-.05-.107-.089-.172-.116-.065-.026-.134-.04-.204-.04-.105 0-.207.03-.294.088-.086.057-.154.138-.193.232-.04.095-.049.2-.027.3.021.1.073.19.148.262l.504.493-.504.493c-.05.047-.09.104-.119.167-.027.062-.042.13-.043.198 0 .068.013.136.04.2.026.063.065.12.114.169.05.048.108.086.173.112.065.026.134.039.204.038.07 0 .139-.015.203-.042.064-.027.122-.067.17-.116l.504-.493.504.493c.048.05.106.089.17.116.064.027.133.041.203.042.07 0 .14-.012.204-.038.065-.026.123-.064.173-.112.05-.049.088-.106.115-.17.026-.063.04-.13.039-.199-.001-.068-.016-.136-.043-.198-.028-.063-.068-.12-.119-.167l-.504-.493.504-.493c.076-.072.129-.164.15-.266.022-.101.012-.206-.029-.302-.04-.095-.11-.177-.198-.233-.089-.057-.193-.086-.299-.083z"
    }
  })]), _vm._v("\n      " + _vm._s(_vm.$t("Notifications")) + "\n    ")]), _vm._v(" "), _c("div", {
    staticClass: "title",
    class: _vm.viewType == "activities" ? "selected" : "",
    on: {
      click: function click($event) {
        _vm.viewType = "activities";
        _vm.getActivities();
      }
    }
  }, [_c("svg", {
    attrs: {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 14 13"
    }
  }, [_c("path", {
    attrs: {
      d: "M1.5 0C.676 0 0 .654 0 1.452v7.741c0 .798.676 1.452 1.5 1.452H3V13l3.652-2.355H11.5c.824 0 1.5-.654 1.5-1.452V1.452C13 .654 12.324 0 11.5 0h-10zm0 .968h10c.281 0 .5.211.5.484v7.741c0 .273-.219.484-.5.484H6.348L4 11.193V9.677H1.5c-.281 0-.5-.211-.5-.484V1.452c0-.273.219-.484.5-.484zm5 1.928c-.824 0-1.5.654-1.5 1.451 0 .465.234.881.594 1.15C4.664 5.846 4 6.72 4 7.741h1c0-.81.664-1.452 1.5-1.452S8 6.933 8 7.742h1c0-1.02-.664-1.894-1.594-2.246.36-.268.594-.684.594-1.149 0-.797-.676-1.451-1.5-1.451zm0 .967c.281 0 .5.212.5.484s-.219.484-.5.484S6 4.62 6 4.347s.219-.484.5-.484z"
    }
  })]), _vm._v("\n      " + _vm._s(_vm.$t("My Activities")) + "\n    ")]), _vm._v(" "), _c("div", {
    staticClass: "buttonDisturb"
  }, [!_vm.mutableConfig || _vm.mutableConfig.paused == 1 || _vm.scheduledDoNotDisturb ? _c("span", {
    key: "doNotDisturb"
  }, [_c("i", {
    staticClass: "fal fa-bell-slash text-danger"
  })]) : _vm.mutableConfig && _vm.mutableConfig.paused == 0 ? _c("span", {
    key: "doDisturb"
  }, [_c("i", {
    staticClass: "fa fa-bell text-primary"
  })]) : _vm._e(), _vm._v(" "), _vm.mutableConfig ? _c("el-tooltip", {
    staticClass: "item",
    attrs: {
      slot: "reference",
      effect: "dark",
      content: _vm.getNotificationText(),
      placement: "bottom"
    },
    slot: "reference"
  }, [_c("el-switch", {
    attrs: {
      "active-color": "#2887eb",
      "active-value": 0,
      "inactive-color": "#DCDFE6",
      "inactive-value": 1,
      disabled: _vm.scheduledDoNotDisturb
    },
    on: {
      change: function change($event) {
        return _vm.saveConfig();
      },
      click: function click($event) {
        _vm.doNotDisturbVisible = _vm.scheduledDoNotDisturb;
      }
    },
    model: {
      value: _vm.mutableConfig.paused,
      callback: function callback($$v) {
        _vm.$set(_vm.mutableConfig, "paused", $$v);
      },
      expression: "mutableConfig.paused"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c("a", {
    on: {
      click: function click($event) {
        return _vm.$router.push("/account/notifications");
      }
    }
  }, [_c("i", {
    staticClass: "fal fa-sliders-h"
  })]), _vm._v(" "), _c("el-dialog", {
    attrs: {
      title: _vm.$t("Set Time Schedule"),
      modal: false,
      visible: _vm.doNotDisturbVisible,
      "show-close": false,
      width: "300px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.doNotDisturbVisible = $event;
      }
    }
  }, [_c("div", {
    staticClass: "dataForm"
  }, [_vm.doNotDisturbText ? _c("h4", [_vm._v(_vm._s(_vm.doNotDisturbText))]) : _vm._e(), _vm._v(" "), _c("span", [_vm._v("\n            " + _vm._s(_vm.$t("Notification is active")) + "\n            "), _c("el-switch", {
    staticClass: "margin-left-5",
    attrs: {
      "active-color": "#2887eb",
      "active-value": 0,
      "inactive-color": "#DCDFE6",
      "inactive-value": 1,
      disabled: _vm.scheduledDoNotDisturb
    },
    on: {
      change: function change($event) {
        _vm.doNotDisturbVisible = true;
      }
    },
    model: {
      value: _vm.mutableConfig.paused,
      callback: function callback($$v) {
        _vm.$set(_vm.mutableConfig, "paused", $$v);
      },
      expression: "mutableConfig.paused"
    }
  })], 1), _vm._v(" "), _c("span", [_vm._v("\n            " + _vm._s(_vm.$t("Paused At Days")) + "\n            "), _c("br"), _vm._v(" "), _c("el-select", {
    staticClass: "width-full",
    attrs: {
      multiple: "",
      placeholder: "Select"
    },
    model: {
      value: _vm.mutableConfig.pausedAtDays,
      callback: function callback($$v) {
        _vm.$set(_vm.mutableConfig, "pausedAtDays", $$v);
      },
      expression: "mutableConfig.pausedAtDays"
    }
  }, _vm._l(_vm.$t("days"), function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1)], 1), _vm._v(" "), _vm.mutableConfig.pausedBetweenTime ? _c("span", [_vm._v("\n            " + _vm._s(_vm.$t("Paused Between Times")) + "\n            "), _c("br"), _vm._v(" "), _c("el-row", {
    attrs: {
      gutter: 6
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-time-select", {
    staticClass: "width-full",
    attrs: {
      placeholder: _vm.$t("Start time"),
      "picker-options": {
        start: "00:00",
        step: "00:15",
        end: "23:59"
      }
    },
    model: {
      value: _vm.mutableConfig.pausedBetweenTime[0],
      callback: function callback($$v) {
        _vm.$set(_vm.mutableConfig.pausedBetweenTime, 0, $$v);
      },
      expression: "mutableConfig.pausedBetweenTime[0]"
    }
  })], 1), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-time-select", {
    staticClass: "width-full",
    attrs: {
      placeholder: _vm.$t("End time"),
      "picker-options": {
        start: "00:00",
        step: "00:15",
        end: "23:59",
        minTime: _vm.mutableConfig.pausedBetweenTime[0]
      }
    },
    model: {
      value: _vm.mutableConfig.pausedBetweenTime[1],
      callback: function callback($$v) {
        _vm.$set(_vm.mutableConfig.pausedBetweenTime, 1, $$v);
      },
      expression: "mutableConfig.pausedBetweenTime[1]"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: function click($event) {
        return _vm.saveConfig();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("Save")))]), _vm._v(" "), _c("el-button", {
    attrs: {
      type: "danger",
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.mutableConfig = _objectSpread({}, _vm.config);
        _vm.doNotDisturbVisible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("Close")))])], 1)])])], 1), _vm._v(" "), _c("el-button", {
    staticClass: "no-border pull-right",
    attrs: {
      icon: "",
      small: "",
      type: "none"
    },
    on: {
      click: function click($event) {
        return _vm.refresh();
      }
    }
  }, [_c("i", {
    staticClass: "fal fa-sync"
  })]), _vm._v(" "), _c("a", {
    staticClass: "no-border pull-right padding-top-10",
    attrs: {
      title: _vm.$t("Mark All Read")
    },
    on: {
      click: function click($event) {
        return _vm.refresh();
      }
    }
  }, [_c("svg", {
    attrs: {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24 "
    }
  }, [_c("path", {
    attrs: {
      fill: "#465669",
      d: "M16.4 0l-5.984 5.784 1.45 1.401 5.984-5.784L16.4 0zm6.15 0L12 10.198 7.6 5.945l-1.45 1.4L12 13 24 1.401 22.55 0zM1.45 5.945L0 7.345l5.383 5.206 1.452-1.403-5.386-5.203z"
    }
  })])])], 1), _vm._v(" "), _vm.viewType == "notification" && _vm.notifications && _vm.notifications[0] ? _c("section", {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: _vm.getNotifications,
      expression: "getNotifications"
    }],
    staticClass: "activityDrawer kv-scroll scrollinside",
    class: _vm.extraClass,
    staticStyle: {
      overflow: "auto"
    }
  }, _vm._l(_vm.notifications, function (note, i) {
    return _c("div", {
      key: "events" + i,
      staticClass: "notification-items"
    }, [_vm.checkDate(i) ? _c("div", {
      staticClass: "headerDate"
    }, [_c("i", {
      staticClass: "fal fa-calendar"
    }), _vm._v("\n        " + _vm._s(_vm._f("onlyDateAndText")(note.notify_on, "DD MMM YY", _vm.$locale)) + "\n      ")]) : _vm._e(), _vm._v(" "), _c("div", {
      staticClass: "notification-item",
      class: note.seen != 0 ? "" : "bordered-left"
    }, [_c("div", {
      staticClass: "columns is-vtop margin-0"
    }, [_c("div", {
      staticClass: "column is-1 margin-top-5 notify-avatar padding-0"
    }, [_c("div", {
      staticClass: "notify-icon"
    }, [note.params.action == "viewNote" ? _c("i", {
      staticClass: "fa fa-comment-alt-check updates-bg",
      class: _vm.checkDate(i) ? "" : ""
    }) : note.params.m == "task" ? _c("i", {
      staticClass: "fa fa-tasks meetings-bg",
      class: _vm.checkDate(i) ? "" : ""
    }) : note.params.m == "deal" ? _c("i", {
      staticClass: "fa meetings-bg",
      class: "fas fa-bullseye-arrow"
    }) : _c("i", {
      staticClass: "fa fa-comment-info comments-bg",
      class: _vm.checkDate(i) ? "" : ""
    })]), _vm._v(" "), note.created_by ? _c("showUsers", {
      attrs: {
        selected_users: [note.created_by],
        nameHidden: true,
        media_size: "medium"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c("div", {
      staticClass: "column paddingLeft"
    }, [_c("div", [_c("div", {
      staticClass: "info"
    }, [_c("strong", [_vm._v(_vm._s(note.created_by_fullname))]), _vm._v(" "), note.params.action == "viewNote" ? _c("span", [_vm._v("\n                  " + _vm._s(_vm.$t("commented")))]) : note.params.m == "task" ? _c("span", {
      attrs: {
        title: note.message
      }
    }, [_vm._v("\n                  " + _vm._s(note.message))]) : _vm._e()]), _vm._v(" "), _c("div", {
      staticClass: "subinfo"
    }, [_vm._v("\n                " + _vm._s(note.notify_time) + " ․\n                "), _c("a", {
      attrs: {
        href: "javascript:;"
      },
      on: {
        click: function click($event) {
          return _vm.getTask(note.params);
        }
      }
    }, [_vm._v(_vm._s(note.params.action == "viewNote" ? note.params.rlb : "#".concat(note.params.r)))])])])])]), _vm._v(" "), _c("div", {
      staticClass: "columns padding-0 margin-0"
    }, [_c("div", {
      staticClass: "column is-full padding-0"
    }, [_c("div", {
      staticClass: "note-detail",
      domProps: {
        innerHTML: _vm._s(note.content)
      },
      on: {
        click: function click($event) {
          return _vm.getTask(note.params);
        }
      }
    }), _vm._v(" "), note.attachments && note.attachments[0] ? _c("ul", {
      staticClass: "el-upload-list el-upload-list--picture-card kv-scroll"
    }, _vm._l(note.attachments, function (att, i) {
      return att.name ? _c("li", {
        key: i,
        staticClass: "el-upload-list__item is-success rel-pos",
        attrs: {
          tabindex: "0"
        }
      }, [_vm.isImageType(att) ? _c("img", {
        staticClass: "objectFile",
        attrs: {
          src: _vm.getAttachmentUrl(att)
        }
      }) : _vm._e(), _vm._v(" "), _c("span", [_c("i", {
        staticClass: "font-sm",
        class: _vm.getFileIcon(att, "fad", "sm")
      })]), _vm._v(" "), _c("span", {
        staticClass: "el-upload-list__title"
      }, [_c("a", {
        attrs: {
          title: att.name
        }
      }, [_vm._v(_vm._s(att.name))])]), _vm._v(" "), _c("span", {
        staticClass: "el-upload-list__item-actions"
      }, [_vm.isImageType(att) ? _c("span", {
        staticClass: "el-upload-list__item-preview",
        on: {
          click: function click($event) {
            return _vm.handleView(att);
          }
        }
      }, [_c("i", {
        staticClass: "el-icon-zoom-in"
      })]) : _vm._e(), _vm._v(" "), _c("span", {
        staticClass: "el-upload-list__item-download",
        on: {
          click: function click($event) {
            return _vm.openFileUrl(att, att.record_id);
          }
        }
      }, [_c("i", {
        staticClass: "el-icon-download"
      })])]), _vm._v(" "), _vm.isImageType(att) ? [_c("div", {
        directives: [{
          name: "viewer",
          rawName: "v-viewer"
        }],
        staticClass: "viewer-images",
        class: "viewer-".concat(att.file_id)
      }, [_c("img", {
        attrs: {
          src: _vm.getAttachmentUrl(att)
        }
      })])] : _vm._e()], 2) : _vm._e();
    }), 0) : _vm._e()])])])]);
  }), 0) : _c("div", [_c("historyTable", {
    attrs: {
      settings: {
        withPadding: true,
        withTitle: false
      }
    }
  })], 1), _vm._v(" "), _vm.loading ? _c("div", {
    staticClass: "divInfo"
  }, [_vm._v(_vm._s(_vm.$t("Loading")))]) : _vm._e(), _vm._v(" "), _vm.noMore ? _c("div", {
    staticClass: "divInfo"
  }, [_vm._v(_vm._s(_vm.$t("No more activity")))]) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };